







































import { Component, Vue } from "vue-property-decorator";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import Employee from "@/app/models/Employee";
// @ts-ignore
import BaseOverview, { Loadable } from "@/resources/components/BaseOverview.vue";
import debounce from "lodash/debounce";
import ArrowLeftSvg from "@/assets/svg/arrow-left.svg";

@Component({
    components: { BaseOverview, LoadingOverlay, LoadSpinner, ArrowLeftSvg }
})
export default class Login extends Vue {
    search: string = '';

    $refs!: {
        overview: BaseOverview,
    };

    doSearch = debounce(() => this.$refs.overview.reset(), 250);

    async login(employee: Employee) {
        await this.task<void>(async () => {
            await this.$store.dispatch('auth/employeeLogin', employee.id);
        });

        await this.$router.replace({ name: 'dashboard' });
    }

    async loadItems(loadable: Loadable) {
        const search = this.search;
        const items = await Employee.index(loadable.page, { search });

        if (search === this.search) {
            loadable.loadItems(items.data);
        }
    }
}
